module.exports = __webpack_public_path__ + "static/img/advantage1.10c5786.webp";


//////////////////
// WEBPACK FOOTER
// ./static/images2/advantage1.webp
// module id = STlU
// module chunks = 2